// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eFjV","label":"styles_label__1XsRm"};